var map = {
	"./analytics.svg": 97510,
	"./assetdynamics.svg": 95680,
	"./cog.svg": 71395,
	"./folder.svg": 64166,
	"./footfall.svg": 91237,
	"./home.svg": 95959,
	"./hourglass_icon.svg": 43732,
	"./link_icon.svg": 52170,
	"./location.svg": 69915,
	"./logo-white.svg": 39151,
	"./logo.svg": 63935,
	"./logowhite.svg": 52034,
	"./menu-down.svg": 59140,
	"./ram-white.svg": 62434,
	"./recognyte_dark.svg": 86819,
	"./rp-text-logo-white.svg": 79416,
	"./rplogowhite.svg": 80816,
	"./settings.svg": 70421,
	"./tiles_icon.svg": 94507,
	"./workflow.svg": 47905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;